/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LineErrorResponse
 */
export interface LineErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof LineErrorResponse
     */
    line: string;
    /**
     * 
     * @type {string}
     * @memberof LineErrorResponse
     */
    message: string;
}

/**
 * Check if a given object implements the LineErrorResponse interface.
 */
export function instanceOfLineErrorResponse(value: object): value is LineErrorResponse {
    if (!('line' in value) || value['line'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function LineErrorResponseFromJSON(json: any): LineErrorResponse {
    return LineErrorResponseFromJSONTyped(json, false);
}

export function LineErrorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineErrorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'line': json['line'],
        'message': json['message'],
    };
}

export function LineErrorResponseToJSON(value?: LineErrorResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'line': value['line'],
        'message': value['message'],
    };
}

